import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import { InfoFilledIcon } from '@sharedCR/coreDesignSystem/icons';

import { PREVIEW_COPY } from '../../previewGeneration.constants';
import { PreviewStepTestIds } from '../../PreviewStep.testIds';

import { emphasisStyles, iconStyles, noteStyles, textStyles } from './PreviewBaselineNote.styles';

const PreviewBaselineNote = () => (
  <Box data-testid={PreviewStepTestIds.BASELINE_NOTE} sx={noteStyles}>
    <Box sx={iconStyles}>
      <InfoFilledIcon size={18} />
    </Box>
    <Typography sx={textStyles} variant="regular14">
      <Typography component="span" sx={emphasisStyles} variant="bold14">
        {PREVIEW_COPY.baselineTitle}
      </Typography>{' '}
      {PREVIEW_COPY.baselineBody}
    </Typography>
  </Box>
);

export default memo(PreviewBaselineNote);
